module.exports = __webpack_public_path__ + "img/quebrada.abfbce4d.jpg";